import { useMemo } from 'react';

import { getClaimOptionCopy } from '../utils/claimOptionCopy';

/**
 * Hook to derive claim flow copy from tag and locStrings.
 * Use in components that have tag and locStrings (e.g. ConfirmClaimTagScreen).
 *
 * @param {Object} tag - Merged tag (with template)
 * @param {Object} locStrings - Localization strings for ProductSwitcher
 * @returns {Object} Copy strings from getClaimOptionCopy
 */
export function useClaimCopy(tag, locStrings) {
  return useMemo(
    () => getClaimOptionCopy({ tag, locStrings }),
    [tag?.product, tag?.claimTerm, locStrings]
  );
}
